import { FormControl, FormHelperText } from "@material-ui/core";
import { FC, useCallback } from "react";
import MaterialChipInput, { BaseTextFieldProps } from "material-ui-chip-input";
import styled from "styled-components";
import useTranslateMessage from "../../hooks/useTranslateMessage";

const StyledChipInput = styled(MaterialChipInput)``;

interface Props extends Omit<BaseTextFieldProps, "error"> {
  value: string[];
  error?: string;
  onBlur: () => void;
  onChange: (newValue: string[]) => void;
}

const ChipInput: FC<Props> = ({ value: chips, error, onBlur, onChange }) => {
  const t = useTranslateMessage();
  const handleSubmit = useCallback(
    (chip: string) => {
      onChange([...chips, chip]);
    },
    [chips, onChange],
  );

  const handleDelete = useCallback(
    (chip: string) => {
      onChange(chips.filter((value) => value !== chip));
    },
    [chips, onChange],
  );

  return (
    <FormControl error={!!error}>
      <StyledChipInput
        placeholder={t({ id: "chipInputPlaceHolder" })}
        error={!!error}
        value={chips}
        onAdd={handleSubmit}
        onDelete={handleDelete}
        onBlur={onBlur}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export { ChipInput };
